// Copyright (c) 2025 Murr (https://github.com/vtstv)
// path: src/web/frontend/src/i18n/locales/en.ts

export const en = {
  common: {
    loading: 'Loading...',
    initializing: 'Initializing...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    back: 'Back',
    confirm: 'Confirm',
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    updating: 'Updating...',
    goBack: 'Go Back',
    viewAll: 'View All',
    noData: 'No data available',
    of: 'of',
  },
  nav: {
    dashboard: 'Dashboard',
    events: 'Events',
    templates: 'Templates',
    settings: 'Settings',
    calendar: 'Calendar',
    compositions: 'Compositions',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Overview of your server\'s events and statistics',
    loadingDashboard: 'Loading dashboard...',
    createEvent: 'Create Event',
    quickAccess: 'Quick Access',
    stats: {
      totalEvents: 'Total Events',
      activeEvents: 'Active Events',
      templates: 'Templates',
      totalParticipants: 'Total Participants',
    },
    quickActions: {
      viewAllEvents: 'View All Events',
      viewAllEventsDesc: 'Manage your server events',
      eventCalendar: 'Event Calendar',
      eventCalendarDesc: 'View events in calendar format',
    },
  },
  events: {
    title: 'Events',
    event: 'event',
    events: 'events',
    showing: 'Showing',
    eventsFound: 'events found',
    loadingEvents: 'Loading events...',
    createEvent: 'Create Event',
    searchPlaceholder: 'Search events by title or description...',
    filters: {
      all: 'All Events',
      scheduled: 'Scheduled',
      active: 'Active',
      completed: 'Completed',
      cancelled: 'Cancelled',
      dateRange: 'Date Range',
      startDate: 'Start Date',
      endDate: 'End Date',
      showFilters: 'Show Filters',
      hideFilters: 'Hide Filters',
      clearFilters: 'Clear Filters',
    },
    status: {
      scheduled: 'Scheduled',
      active: 'Active',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    noEvents: 'No events found',
    noEventsDesc: 'Create your first event to get started',
    viewDetails: 'View Details',
    participants: 'Participants',
    startTime: 'Start Time',
  },
  eventDetails: {
    title: 'Event Details',
    loading: 'Loading event...',
    loadingDetails: 'Loading event details...',
    backToEvents: 'Back to Events',
    backButton: 'Back to Events',
    edit: 'Edit Event',
    composition: 'Composition',
    fullEdit: 'Full Edit',
    participants: 'Participants',
    description: 'Description',
    startTime: 'Start Time',
    maxParticipants: 'Max Participants',
    unlimited: 'Unlimited',
    status: 'Status',
    template: 'Template',
    noDescription: 'No description provided',
    noDescriptionPlaceholder: 'No description (click to add)',
    notFound: 'Event not found',
    notFoundDesc: 'This event may have been deleted',
    deleteConfirm: 'Are you sure you want to delete this event?',
    clickToEdit: 'Click to edit',
    saving: 'Saving...',
    save: 'Save',
    cancel: 'Cancel',
    failedToUpdate: 'Failed to update',
    failedToDelete: 'Failed to delete event',
    createdBy: 'Created by',
    createdAt: 'Created at',
    statistics: 'Statistics',
  },
  createEvent: {
    title: 'Create New Event',
    titleEdit: 'Edit Event',
    subtitle: 'Fill in the details to create a new event',
    subtitleEdit: 'Update event details',
    backToEvents: 'Back to Events',
    save: 'Create Event',
    saveEdit: 'Update Event',
    loadFailed: 'Failed to load channels and templates',
    cancel: 'Cancel',
    createButton: 'Create Event',
    updateButton: 'Update Event',
    creating: 'Creating...',
    updating: 'Updating...',
    fields: {
      title: 'Event Title',
      titlePlaceholder: 'Weekly Raid Night',
      description: 'Description',
      descriptionPlaceholder: 'Join us for our weekly raid night...',
      startTime: 'Start Time',
      maxParticipants: 'Max Participants',
      maxParticipantsHint: '(0 = unlimited)',
      maxParticipantsPlaceholder: '25',
      channel: 'Channel',
      channelRequired: 'required',
      loadingChannels: 'Loading channels...',
      selectChannel: 'Select a channel',
      noChannels: 'No text channels found in this server. Please check bot permissions.',
      channelHint: 'The event message will be posted in this channel',
      template: 'Template (Optional)',
      loadingTemplates: 'Loading templates...',
      noTemplate: 'No Template',
      templateHint: 'Apply roles, limits, and configuration from a template',
    },
  },
  createTemplate: {
    title: 'Create New Template',
    titleEdit: 'Edit Template',
    subtitle: 'Create a reusable template for events',
    subtitleEdit: 'Update your event template settings',
    backToTemplates: 'Back to Templates',
    save: 'Create Template',
    saveEdit: 'Update Template',
    loadFailed: 'Failed to load template',
    cancel: 'Cancel',
    createButton: 'Create Template',
    updateButton: 'Update Template',
    creating: 'Creating...',
    updating: 'Updating...',
    fields: {
      name: 'Template Name',
      namePlaceholder: 'Mythic+ Run',
      maxParticipants: 'Max Participants',
      maxParticipantsHint: '(0 = unlimited)',
      maxParticipantsPlaceholder: '5',
      description: 'Description',
      descriptionPlaceholder: 'Standard Mythic+ dungeon run template',
      allowedRoles: 'Allowed Roles',
      allowedRolesPlaceholder: 'Tank, Healer, DPS',
      allowedRolesHint: 'Comma-separated list of roles',
      roleLimits: 'Role Limits (Optional)',
      roleLimitsPlaceholder: 'Tank:2, Healer:5, DPS:18',
      roleLimitsHint: 'Format: Role:limit, Role:limit (comma-separated pairs)',
      emojiMapping: 'Emoji Mapping',
      emojiMappingPlaceholder: 'Tank:🛡️, Healer:❤️, DPS:⚔️',
      emojiMappingHint: 'Format: Role:Emoji, Role:Emoji (comma-separated pairs)',
      imageUrl: 'Image URL (Optional)',
      imageUrlPlaceholder: 'https://example.com/image.png',
      imageUrlHint: 'Add a banner image to event embeds created from this template',
    },
    help: {
      title: 'Template Tips',
      tip1: 'Templates can be reused for multiple events',
      tip2: 'Allowed roles help participants choose their position',
      tip3: 'Emoji mapping makes signups more visual and engaging',
      tip4: 'Set max participants to enforce group size limits',
    },
    presets: {
      title: 'Quick Presets',
    },
  },
  templates: {
    title: 'Event Templates',
    templatesConfigured: 'templates configured',
    loadingTemplates: 'Loading templates...',
    createTemplate: 'Create Template',
    noTemplates: 'No templates found',
    noTemplatesDesc: 'Create templates to quickly set up recurring events',
    deleteConfirm: 'Are you sure you want to delete this template?',
    deleteFailed: 'Failed to delete template',
    created: 'Created',
    roles: 'Roles',
    roleLimit: 'Role Limit',
    rolesConfigured: 'roles configured',
    maxParticipants: 'Max participants',
    edit: 'Edit',
    delete: 'Delete',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Configure your server preferences',
    loadingSettings: 'Loading settings...',
    saveSettings: 'Save Settings',
    savingSettings: 'Saving...',
    saveSuccess: '✅ Settings saved successfully!',
    saveFailed: '❌ Failed to save settings',
    selectAChannel: 'Select a channel...',
    archiveAfterHours: 'Archive after (hours)',
    add: 'Add',
    clearAllRoles: 'Clear all roles',
    moduleAccessPermissions: 'Module Access Permissions',
    managerHasFullAccess: 'Manager role has full access to all modules regardless of these settings',
    eventsModule: '📅 Events',
    compositionsModule: '⚔️ Compositions',
    templatesModule: '📋 Templates',
    settingsModule: '⚙️ Settings',
    sections: {
      languageTimezone: 'Language & Timezone',
      managerAccess: 'Manager Access',
      automation: 'Automation',
      channels: 'Channels',
      statistics: 'Statistics',
      participantNotes: 'Participant Notes',
    },
    language: {
      title: 'Language',
      description: 'Select your preferred language',
      en: 'English',
      ru: 'Русский',
      de: 'Deutsch',
    },
    timezone: {
      title: 'Timezone',
      description: 'Set your server\'s timezone',
      selectTimezone: 'Select your server timezone. Events will be displayed in this timezone.',
      currentTime: 'Current time',
    },
    managerRoles: {
      title: 'Manager Roles',
      description: 'Select roles that can manage events and settings',
      noRoles: 'No roles selected',
      permissions: 'Permissions',
      canAccessEvents: 'Access Events',
      canAccessCompositions: 'Access Compositions',
      canAccessTemplates: 'Access Templates',
      canAccessSettings: 'Access Settings',
      managerRole: 'Manager Role',
      noManagerRole: '-- No manager role --',
      dashboardAccessRoles: 'Dashboard Access Roles',
      dashboardAccessHint: 'Select roles that can access the dashboard. If empty, only managers can access.',
      currentRoles: 'Current roles:',
      selectRoleToAdd: 'Select role to add',
      addRole: 'Add',
      allPages: 'All pages',
    },
    automation: {
      autoArchive: 'Auto-archive completed events',
      autoArchiveDesc: 'Automatically archive events after completion',
      enableReminders: 'Enable event reminders',
      enableRemindersDesc: 'Send reminders before events start',
      reminderTime: 'Reminder time (hours before)',
      reminderIntervals: 'Reminder Intervals',
      reminderIntervalsHint: 'Comma-separated hours before event',
      reminderIntervalsPlaceholder: '24, 1',
      dmReminders: 'DM Reminders',
      dmRemindersDesc: 'Send direct messages to confirmed participants before events',
      logRetention: 'Log Retention (days)',
      logRetentionHint: 'How long to keep audit logs (0 = forever)',
      logRetentionPlaceholder: '30',
    },
    channels: {
      defaultChannel: 'Default Event Channel',
      defaultChannelDesc: 'Default channel for posting events',
      logChannel: 'Log Channel',
      loggingChannel: 'Log Channel',
      logChannelDesc: 'Channel for audit logs',
      loggingChannelHint: 'Channel for audit logs',
      archiveChannel: 'Archive Channel',
      archiveChannelDesc: 'Channel for archived events',
      archiveChannelHint: 'Channel for archived events',
      selectChannel: 'Select a channel',
      selectChannelOption: '-- Select channel --',
      archiveAfterHours: 'Archive after (hours)',
      approvalChannels: 'Approval Channels',
      approvalChannelsHint: 'Channels requiring manager approval',
      threadChannels: 'Thread Channels',
      threadChannelsHint: 'Channels where event threads are created',
    },
    statistics: {
      enableStats: 'Enable Statistics',
      enableStatsDesc: 'Track and display server statistics',
      enableStatsTracking: 'Enable Statistics Tracking',
      enableTracking: 'Enable Statistics Tracking',
      statsChannel: 'Stats Channel',
      selectChannel: '-- Select channel --',
      updateInterval: 'Update Interval',
      hourly: 'Hourly',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      autoRoleTop10: 'Auto-Role for Top 10',
      top10Role: 'Top 10 Role',
      minEventsRequired: 'Min. Events Required',
    },
    participantNotes: {
      enableNotes: 'Enable Participant Notes',
      enableNotesDesc: 'Allow managers to add notes to participants',
      notesChannels: 'Notes Channels',
      notesChannelsDesc: 'Channels where notes are visible',
      participantNotes: 'Participant Notes',
      allowParticipantNotes: 'Allow participant notes',
      allowNotes: 'Allow participant notes',
      showViewOnlineButton: 'Show \'View online\' button',
      showViewOnline: 'Show \'View online\' button',
      showViewOnlineButtonHint: 'Display link to public event view in Discord messages',
      showViewOnlineDesc: 'Display link to public event view in Discord messages',
      maxNoteLength: 'Max note length',
      maxNoteLengthHint: 'Maximum characters allowed in participant notes (default: 30)',
      maxNoteLengthPlaceholder: '500',
      noteChannels: 'Note channels',
      noteChannelsHint: 'Channels where participants can add notes to their signups. If empty, notes are allowed in all channels.',
      currentChannels: 'Current channels:',
      selectChannelToAdd: 'Select channel to add',
      addChannel: 'Add',
    },
  },
  calendar: {
    title: 'Event Calendar',
    loading: 'Loading calendar...',
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    noEvents: 'No events for this period',
  },
  compositions: {
    title: 'Compositions',
    loading: 'Loading compositions...',
    eventsWithPlans: 'Events with Raid Plans',
    noCompositions: 'No compositions yet',
    noCompositionsDesc: 'Create a composition for an upcoming event to see it here',
    viewComposition: 'View Composition',
    viewEvents: 'View Events',
    slotsFilled: 'Slots filled',
    groups: 'group(s)',
  },
  compositionTool: {
    title: 'Composition Tool',
    loading: 'Loading...',
    saveComposition: 'Save Composition',
    groups: 'Groups',
    bench: 'Bench',
    unassigned: 'Unassigned',
    backToEvent: 'Back to Event',
    saving: 'Saving...',
    viewPublicPage: 'View Public Page',
    profiles: 'Profiles',
    searchParticipants: 'Search participants...',
    noMatches: 'No matches',
    allAssigned: 'All assigned',
    strategyDescription: 'Strategy Description',
    editStrategy: 'Edit',
    editStrategyDescription: 'Edit Strategy Description',
    addStrategy: 'Add Strategy',
    saveStrategy: 'Save Strategy',
    cancel: 'Cancel',
    edit: 'Edit',
    strategyPlaceholder: 'Describe your raid strategy, boss mechanics, player assignments, etc...',
    charactersCount: 'characters',
    characters: 'characters',
    showMore: 'Show more',
    showLess: 'Show less',
    noStrategyYet: 'No strategy description yet. Click "Add Strategy" to add one.',
    strategyPosition: 'Strategy',
    strategyAbove: 'above',
    strategyBelow: 'below',
    toggleStrategyPosition: 'Toggle strategy position',
    dragging: 'Dragging...',
    deleteGroupConfirm: 'Delete this group?',
    addGroup: '+ Add Group',
    clickToEditTitle: 'Click to edit title',
    defaultTitle: 'Raid Composition - Event',
    profilesModal: {
      title: 'Composition Profiles',
      description: 'Save your current Composition into a profile and load it later. The profiles are saved so that other managers of this server can use them as well.',
      saveProfile: 'Save Profile',
      loadProfile: 'Load Profile',
      profileName: 'Profile Name',
      profileNamePlaceholder: 'Enter a profile name...',
      profileDescription: 'Description (optional)',
      profileDescriptionPlaceholder: 'Add a description...',
      loadingPresets: 'Loading presets...',
      noPresets: 'No presets found. Save one first!',
      hasStrategyNotes: 'Has strategy notes',
      groupsCount: 'groups',
      positionsCount: 'positions',
      deleteConfirm: 'Delete this preset?',
    },
  },
  publicEvent: {
    loading: 'Loading event...',
    notFound: 'Event not found',
    notFoundDesc: 'This event may not exist or is not publicly accessible',
    description: 'Description',
    participants: 'Participants',
    confirmed: 'Confirmed',
    pending: 'Pending Approval',
    waitlist: 'Waitlist / Bench',
    noParticipants: 'No participants yet',
    viewRaidPlan: 'View Raid Plan',
    raidPlanAvailable: 'Raid composition plan is available for this event',
  },
  nativeEvents: {
    title: 'Native Discord Events',
    createEvents: 'Create Discord Events',
    createEventsDescription: 'Automatically create native Discord scheduled events for your bot events with dynamic participant updates',
    benefitsTitle: 'Benefits of native Discord events:',
    benefit1: 'Events appear in Discord server calendar',
    benefit2: 'Members can mark as "Interested"',
    benefit3: 'Automatic participant count updates',
    benefit4: 'Events auto-complete or delete when finished',
  },
  landing: {
    hero: {
      title: 'RaidBot',
      subtitle: 'Next-Generation Event Management for Discord',
      description: 'Powerful, flexible, and intuitive. Organize raids, events, and activities with advanced scheduling, templates, and participant management.',
      loginWithDiscord: 'Login with Discord',
      adminLogin: 'Admin login with password',
      hidePasswordLogin: 'Hide password login',
      passwordAuthInfo: 'Password authentication provides access to admin panel only',
      username: 'Username',
      password: 'Password',
      loggingIn: 'Logging in...',
      login: 'Login',
      welcomeBack: 'Welcome back',
      loggedInAs: 'Logged in as',
      goToDashboard: 'Go to Dashboard',
      goToAdminPanel: 'Go to Admin Panel',
      logout: 'Logout',
    },
    features: {
      title: 'Powerful Features',
      subtitle: 'Everything you need to organize and manage Discord events at scale',
      eventScheduling: {
        title: 'Event Scheduling',
        description: 'Create events with custom dates, times, timezone support, and participant limits. Calendar view included!',
      },
      smartParticipants: {
        title: 'Smart Participants',
        description: 'Role-based signup, waitlists, bench overflow, and participant notes for better organization',
      },
      eventTemplates: {
        title: 'Event Templates',
        description: 'Save time with reusable templates including roles, limits, and custom configurations',
      },
      reminders: {
        title: 'Reminders & DMs',
        description: 'Automatic reminders before events, DM notifications, and configurable reminder intervals',
      },
      statistics: {
        title: 'Statistics & Leaderboards',
        description: 'Track participation, no-shows, auto-roles for top participants, and detailed analytics',
      },
      voiceChannels: {
        title: 'Auto Voice Channels',
        description: 'Automatic voice channel creation and cleanup with participant restrictions',
      },
      threads: {
        title: 'Thread Management',
        description: 'Auto-create event threads for discussions, with cleanup and archiving options',
      },
      multiLanguage: {
        title: 'Multi-language',
        description: 'Support for English and Russian with easy extensibility for more languages',
      },
      webDashboard: {
        title: 'Web Dashboard',
        description: 'Full-featured web interface with dark mode, calendar view, and mobile support',
      },
    },
    footer: {
      copyright: '© 2025 RaidBot',
      madeWith: 'Made with',
      by: 'by',
      viewOnGithub: 'View on GitHub',
    },
  },
  errors: {
    accessDenied: 'Access Denied',
    accessDeniedEvents: 'Access Denied: You do not have permission to view Events.',
    accessDeniedTemplates: 'Access Denied: You do not have permission to view Templates.',
    accessDeniedSettings: 'Access Denied: You do not have permission to view Settings.',
    loadFailed: 'Failed to load. Please try again.',
    notFound: 'Not found',
    goToDashboard: 'Go to Dashboard',
    botNotInGuild: {
      title: 'Bot Not In Guild',
      message: 'The bot is not present in this guild. Please invite the bot to use the dashboard.',
      inviteButton: 'Invite Bot',
      backButton: 'Back to Servers',
    },
  },
  panelSelect: {
    welcome: 'Welcome, {username}!',
    subtitle: 'As a bot administrator, you have access to both panels. Choose where you want to go:',
    botAdminPanel: 'Bot Admin Panel',
    botAdminDescription: 'Global bot administration: manage all servers, system settings, and statistics',
    botAdminFeature1: 'All servers access',
    botAdminFeature2: 'Global search and analytics',
    botAdminFeature3: 'System configuration',
    botAdminFeature4: 'Bulk operations',
    openBotAdmin: 'Open Bot Admin →',
    guildAdminPanel: 'Guild Admin Panel',
    guildAdminDescription: 'Manage your Discord servers: events, templates, and server-specific settings',
    guildAdminFeature1: 'Your servers only',
    guildAdminFeature2: 'Event management',
    guildAdminFeature3: 'Template creation',
    guildAdminFeature4: 'Server settings',
    chooseServer: 'Choose Server →',
    backToHome: '← Back to Home',
  },
  serverSelect: {
    title: 'Select a Server',
    subtitle: 'Choose which server to manage',
    loadingServers: 'Loading servers...',
    error: 'Error',
    noServersTitle: 'No Servers Available',
    noServersDescription: 'No servers found where you can manage the bot.',
    makeSure: 'Make sure:',
    requirement1: 'You have MANAGE_GUILD or ADMINISTRATOR permissions',
    requirement2: 'The bot is invited to the server',
    serversAvailable: '{count} server{plural} available',
    owner: '👑 Owner',
    logout: 'Are you sure you want to logout?',
    logoutTitle: '{username} (click to logout)',
    botNotPresent: 'Bot not in this server',
  },
};

export type Translation = typeof en;
